import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { BodyTextM, HeadingL } from "../Typography";

export const Section = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 5,
    }),
);

export const Header = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    }),
);

export const Title = styled(HeadingL)(({ theme }) =>
    theme.unstable_sx({
        m: "0 !important",
        whiteSpace: "nowrap",
    }),
);

export const Card = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        p: { md: 5, xs: 4 },
    }),
);

export const Row = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "stretch", md: "center" },
    }),
);

export const Label = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        display: { md: "block" },
        width: { md: "40%" },
        pr: { md: 4 },
        color: theme.palette.grey.dark,
    }),
);

export const Value = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        width: { md: "60%" },
        minWidth: 0,
        overflowWrap: "anywhere",
    }),
);
